import reducer from "./reducers";

import * as questionAction from "./actions";

export { questionAction };

export default reducer;
